import {Ease} from "../core/Animatable";
import {BaseButton} from "../core/Button";
import {Mix} from "../core/Reflection";
import {Focusable} from "./Focusable";
import {InteractiveSceneItem} from "./InteractiveSceneItem";

export class SceneItemButton extends Mix(BaseButton, Focusable) {

    constructor(item: InteractiveSceneItem) {
        super();

        const t = 0.2;
        const killTweens = () => {
            this.visuals.killTweens();
            const paperCuts = item.getAllPaperCuts();
            for (const paperCut of paperCuts) {
                paperCut.killTweens();
            }
        };

        const onOver = () => {
            killTweens();
            const bounds = this.visuals.getLocalBounds();
            const m = Math.max(bounds.width, bounds.height) * item.getRelativeScale();
            const s = Math.min(1.2, (m + 40) / m);
            const dx = bounds.x + bounds.width / 2 - s * (bounds.x + bounds.width / 2);
            const dy = bounds.y + bounds.height / 2 - s * (bounds.y + bounds.height / 2);
            this.visuals.tweenTo(t, Ease.sineOut, {
                scaleXY: s,
                x: dx,
                y: dy,
                onUpdate: () => {
                    item.updatePaperCut();
                },
            });
        };

        const onOut = () => {
            killTweens();
            this.visuals.tweenTo(t, Ease.sineOut, {
                scaleXY: 1,
                x: 0,
                y: 0,
                onUpdate: () => {
                    item.updatePaperCut();
                },
                onComplete: () => {
                    if (this.isOver && !this.isDown) {
                        onOver();
                    }
                },
            });
        };

        this.onOver.add(onOver);
        this.onDown.add(onOut);
        this.onOut.add(onOut);
    }
}
